import type { ReactNode } from 'react';
import { PageHeader } from '@/components/layout/PageHeader';

interface ModuleSectionLayoutProps {
  section: 'Dashboard' | 'Operations' | 'Reports' | 'Setup' | 'Administration';
  title: string;
  description?: string;
  moduleLabel?: string;
  breadcrumbs?: { label: string; to?: string }[];
  actions?: ReactNode;
  children: ReactNode;
}

export function ModuleSectionLayout({
  section,
  title,
  description = '',
  moduleLabel = 'Org',
  breadcrumbs,
  actions,
  children,
}: ModuleSectionLayoutProps) {
  return (
    <div className="page-content">
      <PageHeader
        title={title}
        description={description}
        breadcrumbs={
          breadcrumbs ?? [
            { label: moduleLabel === 'Administration' ? 'Org' : moduleLabel, to: '/org' },
            { label: section },
          ]
        }
        actions={actions}
      />
      {children}
    </div>
  );
}
